<template>
  <p class="text-xs text-neutral-500 dark:text-neutral-300">
    {{ t('forms.privacyNotice') }}
    <UButton
      variant="link"
      color="inherit"
      size="xs"
      :label="t('forms.privacyNoticeBtnLabel')"
      @click="SwitchPrivacyModal()"
    />.
  </p>
</template>

<script setup lang="ts">
const showPrivacyModal = useState<boolean>('showPrivacyModal')
function SwitchPrivacyModal() {
  showPrivacyModal.value = !showPrivacyModal.value
}

// function render() {
//     return [
//         'This is some text with a ',
//         h(Placeholder)
//     ]
// }
</script>
